import { LensIcon, QuestionIcon, TShirtIcon } from './assets';

export const INFO_URL = 'https://infogram.com/sample-report-mens-casual-1hxj48m7e3gl52v?live';
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

export const CONTACT_EMAIL = 'artem.selikhov@thekroy.pro'
export const CONTACT_TG = 'https://t.me/asktommy'


// Helper functions to get the correct images and icons
export function getMarketplaceImage(key: string): string {
  switch (key) {
    case 'marketplaces': return '/images/flare_jeans_trend.webp';
    case 'brands': return '/images/brands.webp';
    case 'growth': return '/images/jeans_classification.webp';
    case 'prices': return '/images/prices.webp';
    default: return '';
  }
}

export function getUseCaseImage(key: string): string {
  switch (key) {
    case 'growth': return '/images/growth-case.webp';
    case 'competitors': return '/images/competitors-case.webp';
    case 'levels': return '/images/levels-case.webp';
    case 'assortment': return '/images/assortment-case.webp';
    default: return '';
  }
}

export function getWhyWeIcon(key: string): any {
  switch (key) {
    case 'experts': return TShirtIcon;
    case 'models': return LensIcon;
    case 'nuance': return QuestionIcon;
    default: return null;
  }
}

export interface WhyWeImage {
  src: string;
  width: number;
  height: number;
}

export function getWhyWeImage(key: string): WhyWeImage | undefined {
  switch (key) {
    case 'brand': return {
      src: '/images/client-brand-block.webp',
      width: 1497,
      height: 1128
    };
    case 'data': return {
      src: '/images/deep-data-block.webp',
      width: 1546,
      height: 728
    };
    default: return undefined;
  }
}
